import { ConfigProvider } from "antd";
import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import App from "./App";
import "./index.css";
import ReactQueryProvider from "./provider/react_query_provider";
import reportWebVitals from "./reportWebVitals";
import { MessageProvider } from "./provider/AntdNotification";
const ThemedApp = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#F69439",
          colorInfo: "#F69439",
        },
        components: {
          Divider: {
            colorSplit: "#F69439",
          },
        },
      }}
    >
      <App />
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <MessageProvider>
      <ReactQueryProvider>
        <ThemedApp />
        <Toaster position="top-center" reverseOrder={false} />
      </ReactQueryProvider>
    </MessageProvider>
  </React.StrictMode>
);

reportWebVitals();
